"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var material_1 = require("@mui/material");
var approvals_helper_1 = require("../approvals_helper");
var details_field_1 = require("./details_field");
var moment = require("moment");
var react_router_1 = require("react-router");
var button_component_1 = require("../../../../../common/buttons/button_component");
var edit_button_component_1 = require("../../../../../common/buttons/edit_button_component");
var lodash_1 = require("../../../../../utils/lodash");
var menu_constants_1 = require("../../../../../menuList/menu_constants");
var array_helpers_1 = require("../../../../../utils/array_helpers");
var EmployementDetailsApprovalView = function (_a) {
    var previousData = _a.previousData, updatedData = _a.updatedData, isUpdatedData = _a.isUpdatedData, setIsUpdated = _a.setIsUpdated, isUpdated = _a.isUpdated;
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.approvals);
    var id = (0, react_router_1.useParams)().id;
    var pathName = window.location.pathname;
    var levelOneDetails = pathName.includes('level1-details');
    var _b = React.useState(false), isSectionEdit = _b[0], setIsSectionEdit = _b[1];
    var _c = React.useState({}), temporaryData = _c[0], setTemporaryData = _c[1];
    var dateFieldOnchangeHandler = function (value, key) {
        setTemporaryData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    var submitHandler = function () {
        var copy = lodash_1.default.cloneDeep(temporaryData);
        var employmentDetails = {};
        if ((copy === null || copy === void 0 ? void 0 : copy.dateOfJoining) && (copy === null || copy === void 0 ? void 0 : copy.dateOfJoining) !== '--') {
            employmentDetails['date_of_joining'] = moment(copy === null || copy === void 0 ? void 0 : copy.dateOfJoining).format('YYYY-MM-DD');
        }
        (0, approvals_helper_1.updateFeDetails)({ employment_details: employmentDetails, is_approval_flow: 1 }, id)
            .then(function (res) {
            if (res.data.statusCode === 200) {
                setIsSectionEdit(!isSectionEdit);
                setIsUpdated(!isUpdated);
                setTemporaryData({});
            }
        });
    };
    return (React.createElement("div", { className: "visit-details" },
        features[menu_constants_1.FEATURE_CONSTANTS.FELevelOneEdit] &&
            levelOneDetails &&
            React.createElement(material_1.Grid, { display: 'flex', justifyContent: 'end', sx: { margin: '0px 0px 10px' } }, !isSectionEdit ?
                React.createElement(edit_button_component_1.default, { buttonName: "Edit", onClickHandler: function () { return setIsSectionEdit(!isSectionEdit); } })
                :
                    React.createElement(material_1.Box, { sx: { display: 'flex', gap: '10px' } },
                        React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", onClickHandler: function () {
                                setIsSectionEdit(!isSectionEdit);
                                setTemporaryData({});
                            } }),
                        React.createElement(button_component_1.default, { buttonName: "Submit", color: "yellow", onClickHandler: submitHandler }))),
        React.createElement(material_1.Grid, { container: true, spacing: 2, columns: 12, className: "details-profile-grid" },
            React.createElement(material_1.Grid, { item: true, xs: isUpdatedData
                    ? 6
                    : 12, container: true },
                isUpdatedData && (React.createElement(material_1.Grid, { className: "tab-heading-wrapper", item: true, xs: 12 },
                    React.createElement("div", { className: "tab-heaidng profile-detail-heaidng" },
                        React.createElement("h2", null, "Previous Data")))),
                React.createElement(material_1.Grid, { item: true, xs: 12, container: true, className: "mini-details-wrapper" }, previousData &&
                    Object.entries(approvals_helper_1.approvalsFormConstants.employment_details)
                        .filter(function (_a) {
                        var key = _a[0];
                        return key in previousData;
                    })
                        .map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return (React.createElement(details_field_1.default, { key: key, fieldKey: key, value: isUpdatedData ? previousData[key] : (key in temporaryData ? temporaryData[key] : previousData[key]), lableName: value.label, isEditable: isUpdatedData ? false : value.editable, fieldType: value.type, dateFieldOnchangeHandler: dateFieldOnchangeHandler, isSectionEdit: isUpdatedData ? false : isSectionEdit, showEmpty: true }));
                    }))),
            updatedData &&
                isUpdatedData && (React.createElement(material_1.Grid, { item: true, xs: 6, container: true },
                React.createElement(material_1.Grid, { className: "tab-heading-wrapper", item: true, xs: 12 },
                    React.createElement("div", { className: "tab-heaidng profile-detail-heaidng" },
                        React.createElement("h2", null, "Updated Data"))),
                React.createElement(material_1.Grid, { item: true, xs: 12, container: true, className: "mini-details-wrapper" }, updatedData &&
                    Object.entries(approvals_helper_1.approvalsFormConstants.employment_details)
                        .filter(function (_a) {
                        var key = _a[0], value = _a[1];
                        return key in updatedData || (value.editable && isSectionEdit);
                    })
                        .map(function (_a) {
                        var _b, _c;
                        var key = _a[0], value = _a[1];
                        return (React.createElement(details_field_1.default, { key: key, fieldKey: key, lableName: value.label, value: key in temporaryData ? ((_b = temporaryData[key]) !== null && _b !== void 0 ? _b : '--') : ((_c = updatedData[key]) !== null && _c !== void 0 ? _c : '--'), isEditable: isUpdatedData ? value.editable : false, fieldType: value.type, dateFieldOnchangeHandler: dateFieldOnchangeHandler, isSectionEdit: isUpdatedData ? isSectionEdit : false, showEmpty: false }));
                    })))))));
};
exports.default = EmployementDetailsApprovalView;
